<template>
    <div class="full-parent wrap-question-answer">
        <iframe v-if="typeFile == FILE_YOUTUBE" class="full-parent" :src="emberYoutube(item.path)"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        <!-- <VueDocPreview v-if="typeFile == TYPE_DOCUMENT" class="full-parent" :value="apiUrl + item.path" :type="'office'" /> -->
            <!-- <iframe v-if="typeFile == TYPE_DOCUMENT" class="full-parent" :src="`https://docs.google.com/gview?url=${apiUrl + item.path}&embedded=true`" frameborder="0">
            </iframe> -->
            <iframe v-if="typeFile == TYPE_DOCUMENT" class="full-parent" :src="`https://view.officeapps.live.com/op/embed.aspx?src=${apiUrl + item.path}`" frameborder="0">
            </iframe>
            <div class="full-parent postion-relative" v-if="typeFile == TYPE_FILE_PDF">
                <iframe :src="apiUrl + item.path" download="" class="full-parent" >
            
                </iframe >
                <div v-if="isShowHideDownload" class="hide-download-pdf"></div>
            </div>
        
        <div class="full-parent over-flow-auto" v-if="typeFile == TYPE_TEST">
            <div class="row col-md-12 full-parent">
                <div class="col-md-9 question-item mb-3" >
                    <div class="display-flex-column question">
                        <div class="q-top">
                            <p class="text-primary m-0 float-left">Câu hỏi:</p> 
                            <p class="m-0 p-no-margin fit-height-question" v-html="questionItem.content"></p>
                        </div>
                        <!-- <img v-if="questionItem.fileQuestion.url"
                            :style="{ 'width': questionItem.withSize + 'px', 'height': questionItem.heightSize + 'px' }"
                            :src="questionItem.fileQuestion.url" /> -->
                        <div class="q-bottom display-flex-column wrap-list-answer">
                            
                            <div  style="margin-top: 10px;" v-for="(item, index) of questionItem.listAnswer" :key="index" class="list-answer row col-md-12">
                                <div class="col-md-8">
                                        <div class="item__first">
                                            <div class="answer-correct display-flex-center">
                                                <b-checkbox :class="{'is-true-answer-check-box':questionItem.isShowAnswer &&  item.isTrue,
                                                // 'is-false-answer-check-box':questionItem.isShowAnswer && !item.isTrue
                                                 
                                             }" :disabled="!isEnableWork || questionItem.isShowAnswer" v-model="item.userFillAnswer" :value="item.isTrue"></b-checkbox>
                                                {{ item.isShowAnswer,  item.typeUserAnswer }}
                                                <span :class="{'is-true-answer':questionItem.isShowAnswer &&  item.isTrue,
                                                // 'is-false-answer':questionItem.isShowAnswer && !item.isTrue
                                                 
                                             }" class="p-no-margin mb-1 display-flex" v-html="GetAnphabet(index,item.content) + item.content"></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="item.fileAnswer.url" class="item__img col-md-4">
                                        <div class="image-question">
                                            <img :src="item.fileAnswer.url" />
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="row">
                        <div @click="handleOnChangeQuestion(item)" class="col-md-2 number-question" v-for="(item, index) of listQuestion"
                        :key="index" :class="{'is-choose':item.id== questionItem.id,'is-true':item.typeUserAnswer==2,'is-false':item.typeUserAnswer==3}">
                            {{ index+1 }}
                        </div>
                    </div>
                    <div class="row wrap-btn-confirm">
                        <button type="button"
                        v-if="isEnableWork"
                        :disabled="questionItem.typeUserAnswer==1?false:true"
                        class="btn btn-main btn-confirm border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                        @click="handleUserAnswerQuestion"
                        >
                        Xác nhận
                    </button>
                    </div>
                </div>
            </div>
            

        </div>
        <iframe  v-if="typeFile == TYPE_H5P" class="full-parent" :src="emberH5p(item.path)"
            title="YouTube video player" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen></iframe>
        <iframe v-if="typeFile == FILE_CANVA" class="full-parent" :src="embedCanva(item.path)"
            title="canva" frameborder="0"
            allow="camera *;microphone *;accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; camera *;microphone *"
            allowfullscreen></iframe>
            
    </div>

</template>
<script>

import {
    TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
    TYPE_FILE_PDF, TYPE_FILE_POWERPOINT, TYPE_FILE_WORD, TYPE_FILE_EXCEL, TYPE_FILE_IMAGE
} from './../constants/constants_enum'
import VueDocPreview from 'vue-doc-preview'
import { APP_CONFIG } from "@/utils/constants";
import { getDetail } from './../_api/lessonQuestionClassSchoolServices'
import {saveUserLessonAnswerQuestion} from './../_api/userLessonAnswerQuestionClassSchool'
import pdf from 'vue-pdf'
export default {
    components: {
        VueDocPreview,
        pdf
    },
    props: {
        item: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        },
        isEnableWork :{
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false
        },
        isShowAnswer :{
            type: Boolean,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: false
        },
    },
    watch:{
        'item.id':'onChangeDataDocument'
    },
    data() {
        return {

            isShowHideDownload:false,
            TYPE_H5P, TYPE_DOCUMENT, TYPE_TEST, FILE_YOUTUBE, FILE_CANVA, FILE_LINK,
            TYPE_FILE_PDF, TYPE_FILE_POWERPOINT, TYPE_FILE_WORD, TYPE_FILE_EXCEL, TYPE_FILE_IMAGE,
            //apiUrl: 'https://apihanhtrangso-uat.hiser.vn/lessons/',//APP_CONFIG.apiUrl + '/lessons/',
            apiUrl: APP_CONFIG.apiUrl + '/lessons/',
            viewh5p:APP_CONFIG.viewh5p+'viewh5p',
            typeFile: 0,
            listTypeDocument: [
                { value: TYPE_H5P, text: 'Bài giảng tương tác H5P' },
                { value: TYPE_DOCUMENT, text: 'Dạng tài liệu' },
                { value: TYPE_TEST, text: 'Dạng kiểm tra' },
                { value: FILE_YOUTUBE, text: 'Dạng youtube' },
                { value: FILE_CANVA, text: 'Dạng canva' },
                { value: FILE_LINK, text: 'Dạng nhúng' },
            ],
            listQuestion: [],
            cdnUrl: APP_CONFIG.bookCdnUrl + 'data/lesson/',
            question_img_size: [
                { value: 4, text: '456x336' },
                { value: 3, text: '1032x584' },
                { value: 2, text: '1032x176' },
                { value: 1, text: '240x176' }
            ],
            questionItem:{},
            test:true,
            listAnphabet :["A.", "B.", "C.", "D.", "E.", "F.", "G.", "H.", "I.", "J.", "K.", "L.", "M.", "N.", "O.", "P.", "Q.", "R.", "S.", "T.", "U.", "V.", "W.", "X.", "Y.", "Z."]
        }
    },
    mounted() {
        this.onChangeDataDocument()
        
        
    },
    methods: {
        checkExists(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.open('HEAD', url, true);

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    var contentType = xhr.getResponseHeader('Content-Type');
                    callback(contentType === 'application/pdf');
                } else {
                    callback(false);
                }
                }
            };

            xhr.send();
        },
        GetAnphabet(index,content){
            if(index>25){
                index = 25
            }
            console.log(content,this.listAnphabet[index])
            if(content.includes(this.listAnphabet[index])){
                return ''
            }
            return this.listAnphabet[index]+ '&nbsp;'
        },
        onChangeDataDocument() {
            if (!this.item) {
                return
            }
            else {
                this.typeFile = this.item.typeDocument
            }
            if (this.typeFile == TYPE_TEST) {
                this.getDetailQuestion()
            }
            //nếu là Dạng nhúng
            if (this.typeFile == FILE_LINK) {
                window.open(this.fixUrl(this.item.path), '_blank');
            }
            //là dạng tài liệu
            else if (this.typeFile == TYPE_DOCUMENT) {
                if (this.item.path.endsWith('.pdf')) {
                    this.typeFile = TYPE_FILE_PDF
                    let self = this
                    this.checkExists(this.apiUrl + this.item.path,function (exists) {
                        if (exists) {
                            console.log('PDF file exists.');
                            self.isShowHideDownload = true
                        } else {
                            console.log('PDF file does not exist.');
                            self.isShowHideDownload = false
                        }
                    })
                }
                else {
                    this.typeFile = TYPE_DOCUMENT

                }
            }
            //dạng canva
            else if(this.typeFile == FILE_CANVA){
                
            }
        },
        handleUserAnswerQuestion(){
            
            let isUserFillTrue = false
            for (let i = 0; i < this.questionItem.listAnswer.length; i++) {
                const item = this.questionItem.listAnswer[i];
                if(item.isTrue === true && item.userFillAnswer === true){
                    isUserFillTrue =true
                    
                }
                else if(item.isTrue === false && item.userFillAnswer === false){
                    isUserFillTrue = false
                    break
                }
                else if(item.isTrue === true && item.userFillAnswer === ''){
                    isUserFillTrue = false
                    break
                }
            }
            console.log(isUserFillTrue)
            if(isUserFillTrue){
                this.questionItem.typeUserAnswer = 2
            }
            else{
                this.questionItem.typeUserAnswer = 3
            }
            this.questionItem.isShowAnswer=true
            // for (let i = 0; i < this.listQuestion.length; i++) {
            //     let item = this.listQuestion[i];
            //     if(item.id== this.questionItem.id){
            //         item = this.questionItem
            //         break
            //     }
            // }
            this.test=!this.test
            console.log(this.questionItem)
            // gửi thông xin trả lời cầu hỏi xuống dưới client
            let lessonClassSchoolId = this.$route.query.id
            let classSchoolId = this.$route.query.classSchoolId
            if(lessonClassSchoolId >0 && classSchoolId>0){
                let params={
                    classSchoolId:classSchoolId,
                    lessonClassSchoolId:lessonClassSchoolId,
                    lessonQuestionId:this.questionItem.id,
                    typeUserAnswer:this.questionItem.typeUserAnswer,
                    correct:this.questionItem.correct
                }
                saveUserLessonAnswerQuestion(params).then((res)=>{
                    if (res && res.data && !res.errors) {

                    }
                })
            }
            let isDowork=true
            for (let i = 0; i < this.listQuestion.length; i++) {
                const element = this.listQuestion[i];
                if(element.typeUserAnswer==1){
                    isDowork = false
                    break
                }
            }
            if(isDowork){
                this.$emit('handleDoWorDone',this.item)
            }
        },
        handleOnChangeQuestion(item){
            this.questionItem = item
        },
        getDetailQuestion() {
            let self = this
            this.listQuestion= []
            let lessonClassSchoolId = this.$route.query.id
            let classSchoolId = this.$route.query.classSchoolId
            let params={
                lessonClassSchoolId:lessonClassSchoolId,
                classSchoolId:classSchoolId,
                documentId:this.item.id
            }
            getDetail(params).then(res => {
                if (res && res.data && !res.errors) {

                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        let listAnswer = []
                        for (let j = 0; j < item.listLessonAnswerClassSchoolModels.length; j++) {
                            const element = item.listLessonAnswerClassSchoolModels[j];
                            let answer = {
                                id: element.id,
                                idClient: this.generateUUID(),
                                isTrue: element.isTrue,
                                content: element.content,
                                fileAnswer: {
                                    fileData: null,
                                    url: element.path ? `${this.cdnUrl}${element.path}` : '',
                                },
                                userFillAnswer:!this.isEnableWork?(element.isTrue==true?element.isTrue:''):''
                            }
                            listAnswer.push(answer)
                        }


                        let question = {
                            id: item.id,
                            idClient: this.generateUUID(),
                            lessonClassSchoolId: item.lessonClassSchoolId,
                            topicName: '', // tên đề bài
                            sizeImage: 1, // kích cỡ ảnh
                            withSize: 240,
                            heightSize: 176,
                            fileQuestion: {
                                fileData: null,
                                url: ''
                            },
                            content: item.content,
                            typeUserAnswer:1,//item.userLessonAnswer?item.userLessonAnswer.typeUserAnswer:1,
                            isShowAnswer:false,//item.userLessonAnswer?true:false,
                            correct:'',//item.userLessonAnswer?item.userLessonAnswer.correct:'',
                            
                            listAnswer: listAnswer,
                        }
                        this.listQuestion.push(question)
                    }
                    if(this.listQuestion.length>0){
                        this.questionItem = this.listQuestion[0]
                    }
                   
                }
            })
        },
        generateUUID() { // Public Domain/MIT
            var d = new Date().getTime();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
                d += performance.now(); //use high-precision timer if available
            }
            var newGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });

            return newGuid;
        },
        answerDefault() {
            return {
                id: 0,
                idClient: this.generateUUID(),
                isTrue: false,
                content: '',
                fileAnswer: {
                    fileData: null,
                    url: ''
                },
            }
        },
        fixUrl(url) {
            // Kiểm tra nếu URL không bắt đầu bằng "https://"
            if (!url.startsWith("https://")) {
                // Thêm "https://" vào đầu URL
                url = "https://" + url;
            }
            
            return url;
        },
        embedCanva(url){
            if(url){
                let baseUrl = url.split('?')[0];
                let embeddedUrl = baseUrl.replace("/edit", "/view?embed");
                return embeddedUrl
            }
            return url
        },
        getId(url) {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);

            return (match && match[2].length === 11)
                ? match[2]
                : null;
        },
        emberH5p(url) {
            
            return `${this.viewh5p}?nameFile=${url}`
        },
        emberYoutube(url) {
            const videoId = this.getId(url);
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);
            return `https://www.youtube.com/embed/${videoId}`
        }
    }
}
</script>
<style>
.is-false-answer-check-box .custom-control-label::before {
    background-color: red !important;
}
.is-false-answer-check-box .custom-control-label::after {
    background-color: red !important;
}
.is-true-answer-check-box .custom-control-label::before {
    background-color: green !important;
}
.is-true-answer-check-box .custom-control-label::after {
    background-color: green !important;
}
</style>
<style lang="scss" scoped>
.postion-relative{
    position: relative;
}
.hide-download-pdf{
    position: absolute;
    width: 35px;
    height: 35px;
    top: 10px;
    right: 85px;
    background: #323639;
}
.wrap-btn-confirm{
    display: flex;
    justify-content: center;
}
.margin-top-10{
    margin-top: 10px;
}
.wrap-list-answer{
    overflow: auto;
    height: 100%;
}
.list-answer{
    max-height: 8rem;
    overflow: auto;
}
.fit-height-question{
    max-height: 20rem;
    overflow: auto;
}
.justify-content-end{
    justify-content: end;
}
.is-true-answer{
    color: green !important;
}
.is-false-answer{
    color: red !important;
    
}
.is-true{
    background-color: green !important;
    color: white !important;
}
.is-false{
    background-color: red !important;
    color: white !important;
}
.is-choose{
    border: 2px solid blue !important;
}
.btn-confirm{
    width: 100px;
}
.number-question{
    width: 100%;
    border: 1px solid gray;
    border-radius: 10px;
    margin: 5px;
    cursor: pointer;
    color: black;
}
.full-parent {
    width: 100% !important;
    height: 100% !important;
}
.over-flow-auto {
    overflow: auto;
    
}
.question-item {

    border: 1px solid gray;
    border-radius: 15px;
    padding: 5px;
}
.float-left {
    float: left;
}
.wrap-question-answer {
    background: white;
    border-radius: 8px;
    padding: 1rem;
}
</style>
<style lang="scss">
.p-no-margin p {
    margin: 0;
}
</style>